import axios from "axios";
import { toast } from "react-toastify";
import history from "../config/history";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL + "/api/v1",
});

instance.interceptors.request.use((config) => {
  const apiToken = localStorage.getItem("token");
  config.headers.Authorization = `Bearer ${apiToken}`;

  // config.headers = {
  //   authorization: "Bearer " + apiToken,
  // }; // add apiTOken
  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      // console.log("You are not authorized");
      // TOAST MESSAGE
    }
    if (response.status >= 500) {
      toast.error("SERVER ERROR");
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      toast.error("Token expired, Please Re-login", { hideProgressBar: true });
      setTimeout(() => {
        history.replace("/auth/login");
        window.location.reload();
      }, 2000);
    }

    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
  }
);

export const http = instance;
